/** Clinic admin: payment at booking, per doctor at the active clinic. */
import { fetchApi } from '../client';
import type { BookingPaymentSetting, PaymentGatewayView } from './doctorListing';

export interface BookingPaymentDoctorRow {
  doctorId: string;
  name: string;
  specialization?: string | null;
  setting: BookingPaymentSetting;
}

export interface BookingPaymentsOverview {
  gateway: PaymentGatewayView;
  gatewayReady: boolean;
  doctors: BookingPaymentDoctorRow[];
}

export const bookingPaymentsModule = {
  overview: () => fetchApi<BookingPaymentsOverview>('/api/clinic/booking-payments'),
  update: (doctorId: string, collectAtBooking: boolean, amount: number | null) =>
    fetchApi<BookingPaymentSetting>(`/api/clinic/booking-payments/${encodeURIComponent(doctorId)}`,
      { method: 'PUT', body: JSON.stringify({ collectAtBooking, amount }) }),
};
